import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import TextInput from '../common/text-input/TextInput';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import classnames from 'classnames';

import './CouponInput.scss';

const CouponInput = ({ onApply, onRemove, isValid, couponName, discount, disabled }) => {
    const [discountValue, setDiscountValue] = useState(discountValue);
    const [isCouponSet, setIsCouponSet] = useState(false);
    const [coupon, setCoupon] = useState(couponName);
    const { t } = useTranslation();

    const onCouponSubmit = () => {
        onApply?.(coupon);
    };

    const wrapperClassnames = classnames({
        displayOnly: isCouponSet
    }, 'couponInput');


    const removeCoupon = () => {
        setCoupon('');
        setIsCouponSet(false);
        onRemove();
    };

    useEffect(() => {
        setIsCouponSet(isValid);
    }, [isValid]);

    useEffect(() => {
        setDiscountValue(discount);
    }, [discount]);

    const inputComponents = !isCouponSet ? (
        <>
            <td colSpan="2">
                <TextInput initialValue={coupon} placeholder={t('Discount code')} onChange={setCoupon} onSubmit={onCouponSubmit} disabled={disabled}/>
            </td>
            <td>
                <Button disabled={coupon.length === 0 || disabled} onClick={onCouponSubmit} variant="outline-secondary">{t('Apply')}</Button>
            </td>
        </>
    ) : null;

    const displayComponents = isCouponSet? (
        <>
            <td>
                <div className="couponName">
                    <span>{t('Discount code applied')}</span>
                    <span className="codeValue">{coupon}</span>
                </div>
            </td>
            <td>
                <div className="removeCoupon" onClick={removeCoupon}>{t('remove')}</div>
            </td>
            <td>
                <div className="discountValue">-{discountValue}</div>
            </td>
        </>
    ) : null;

    return (
        <tr className={wrapperClassnames}>
            {inputComponents}
            {displayComponents}
        </tr>
    );
};

CouponInput.defaultProps = {
    couponName: ''
};

CouponInput.propTypes = {
    couponName: PropTypes.string,
    discount: PropTypes.string,
    isValid: PropTypes.bool,
    onApply: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};


export default CouponInput;
